import React from 'react';

interface CookieConsentBannerProps {
  showCookieConsent: boolean;
  handleCookieConsent: (accepted: boolean) => void;
}

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({
  showCookieConsent,
  handleCookieConsent,
}) => {
  if (!showCookieConsent) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-gray-100 p-4 shadow-lg z-50"
      role="alert"
      aria-live="polite"
    >
      <div className="max-w-full mx-2 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-gray-700 text-sm">
          Utilizamos cookies para melhorar sua experiência em nosso site. Eles nos ajudam a entender como você interage com nosso conteúdo e a personalizar sua experiência. Para saber mais sobre como utilizamos cookies, consulte nossa <a href="/privacidade" target="_blank" rel="noopener noreferrer" className="text-blue-900 hover:text-blue-500">Política de Privacidade</a>.
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => handleCookieConsent(true)}
            className="bg-[#2a3c5c] text-white px-4 py-2 rounded-lg hover:bg-[#3a4c6c] transition-colors whitespace-nowrap"
            aria-label="Aceitar todos os cookies"
          >
            Aceitar cookies
          </button>
          <button
            onClick={() => handleCookieConsent(false)}
            className="text-gray-600 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            aria-label="Recusar cookies não essenciais"
          >
            Recusar cookies não essenciais
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

